/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { colors, FlexContainer, Form, H2, Stack, Text } from "@carrotfertility/carotene"
import { FormArrowSubmitButton } from "features/legacy-components/ArrowSubmitButton"
import { BackArrow } from "components/views/atoms/Molecules"
import { Progress } from "components/views/modal/Progress"
import { useStateMachine } from "components/context/stateMachine/StateMachineV2"
import { FormRadioButton, FormRadioGroup } from "features/legacy-components/FormRadioGroup"
import styled from "styled-components"
import { SelectButtonProps } from "components/views/atoms/buttons/SelectButton"
import { useReimbursementContext } from "components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"

export const SelectButtonLabel = styled.label<SelectButtonProps>(
  ({ outline }) => ({
    width: "100%",
    margin: "2px",
    padding: "8px 32px",
    background: "white",
    textAlign: "center",
    fontFamily: '"Gotham A", "Gotham B", sans-serif',
    fontSize: "16px",
    lineHeight: "150%",
    borderRadius: "20px",
    border: `2px solid ${outline ? "#E48400" : colors.base.black10}`,
    cursor: "pointer",
    ":focus,:hover": {
      background: "#f9ead5"
    }
  }),
  ({ disabled, outline }) =>
    disabled && {
      color: "#CCCCCC",
      cursor: "not-allowed",
      background: "#F5F5F5",
      border: `2px solid ${outline ? "#CCCCCC" : "#F5F5F5"}`,
      ":focus,:hover": {
        background: "#F5F5F5"
      }
    }
)
export const AboutThisExpenseRelatedToStepchildAdoption = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const { state, updateStepchildAdoption } = useReimbursementContext()
  const onSubmit = (value): void => {
    updateStepchildAdoption(value.isStepchildAdoption)
    send("")
  }
  const intl = useIntl()

  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "About This Expense" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={back} />
      <Form onSubmit={onSubmit}>
        <Stack minHeight="500px" paddingTopBottom="huge">
          <H2 id="step-heading">
            <FormattedMessage defaultMessage="Is this related to adopting a spouse's child (stepparent adoption)?" />
          </H2>
          <Text>
            <FormattedMessage
              defaultMessage="This helps us determine whether an expense is taxable so we can process reimbursements in a legally
            compliant way."
            />
          </Text>
          <FormRadioGroup
            aria-labelledby="step-heading"
            name="isStepchildAdoption"
            useFieldOptions={{
              defaultIsTouched: true,
              validate: (value) => (value ? false : "error"),
              defaultValue: state?.isStepchildAdoption
            }}
          >
            <FlexContainer stack="huge">
              <FormRadioButton
                submitOnClick={false}
                label={intl.formatMessage({ defaultMessage: "Yes" })}
                value="true"
                as={SelectButtonLabel}
              />
              <FormRadioButton
                submitOnClick={false}
                label={intl.formatMessage({ defaultMessage: "No" })}
                value="false"
                as={SelectButtonLabel}
              />
            </FlexContainer>
          </FormRadioGroup>
        </Stack>
        <FlexContainer paddingTopBottom="huge" justifyContent="flex-end">
          <FormArrowSubmitButton>
            <FormattedMessage defaultMessage="Continue" />
          </FormArrowSubmitButton>
        </FlexContainer>
      </Form>
    </>
  )
}
